/* eslint-disable */
import crypto from 'crypto';
import {
  always,
  compose,
  then,
} from 'ramda';
import { promisify } from 'util';
import { async as asyncUtils } from '@555platform/utility-belt.js';

const generateKeyPairPromise = promisify(crypto.generateKeyPair);

const randomBytesPromise = promisify(crypto.randomBytes);

/**
 * curve safety info: http://safecurves.cr.yp.to/
 * ans1 encoding structure required by aum: https://golang.org/src/crypto/x509/sec1.go
 */
const keyPairOptions = Object.freeze({
  modulusLength: 4096,
  namedCurve: 'prime256v1',
  publicKeyEncoding: {
    type: 'spki',
    format: 'pem',
  },
  privateKeyEncoding: {
    type: 'sec1',
    format: 'pem',
  },
});

// https://nodejs.org/api/crypto.html#crypto_crypto_generatekeypair_type_options_callback
export const generateKeyPair = () => generateKeyPairPromise('ec', keyPairOptions);

const DEFAULT_ID_LENGTH = 20;

const DEFAULT_SECRET_LENGTH = 50;

const generateRandomString = compose(
  then(buffer => buffer.toString('hex')),
  randomBytesPromise,
);

export const generateClientId = compose(
  generateRandomString,
  always(DEFAULT_ID_LENGTH),
);

export const generateClientSecret = compose(
  generateRandomString,
  always(DEFAULT_SECRET_LENGTH),
);

export const generateCredentials = () => asyncUtils.flatten({
  clientID: generateClientId(),
  clientSecret: generateClientSecret(),
});

export default {
  generateKeyPair,
  generateClientId,
  generateClientSecret,
};
